import { Link } from 'react-router-dom'
import type { LucideIcon } from 'lucide-react'

export interface SummaryCardProps {
  icon: LucideIcon
  label: string
  count: number
  to: string
}

export function SummaryCard({ icon: Icon, label, count, to }: SummaryCardProps) {
  return (
    <Link
      to={to}
      className="flex flex-col gap-3 rounded-control border border-border bg-surface p-4 transition-colors hover:border-accent/60"
    >
      <div className="flex items-center gap-2 text-text-secondary">
        <Icon size={16} strokeWidth={1.5} />
        <span className="text-meta font-medium">{label}</span>
      </div>
      <span className="text-title font-semibold text-text-primary">{count}</span>
    </Link>
  )
}
